import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Header, Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import useReward from '@/screens/Rewards/List/useReward';

import CardUpdateButton from './CardUpdateButton';
import RewardCardTable from './RewardCardTable';

const Details = () => {
  const params = useParams();
  const rewardId = params?.id || '';
  const {
    isCardLoading,
    fetchCardList,
    cardList: list,
    cardTotal: total,
    item,
  } = useReward();

  useEffect(() => {
    if (rewardId) {
      // Fire-and-forget: fetchCardList catches and surfaces its own failures,
      // so this only stops an unexpected throw becoming an unhandled rejection.
      fetchCardList({}, rewardId).catch(() => {});
    }
  }, [rewardId, fetchCardList]);

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={`${item?.name || ''} Reward Item`} />

      <PermissionsProvider permission={AfriexAdminPermission.RewardManage}>
        <div className="w-full flex justify-end">
          <CardUpdateButton rewardId={rewardId} />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isCardLoading ? <TableSkeleton /> : <RewardCardTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchCardList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};
export default Details;
